/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type EventTypeCountStats = {
    eventType?: EventTypeCountStats.eventType;
    count?: number;
};
export namespace EventTypeCountStats {
    export enum eventType {
        STATIC_WIDGET_CLOSED = 'STATIC_WIDGET_CLOSED',
        STATIC_WIDGET_OPENED = 'STATIC_WIDGET_OPENED',
        STATIC_WIDGET_SHOWN = 'STATIC_WIDGET_SHOWN',
        DYNAMIC_WIDGET_CLOSED = 'DYNAMIC_WIDGET_CLOSED',
        DYNAMIC_WIDGET_OPENED = 'DYNAMIC_WIDGET_OPENED',
        DYNAMIC_WIDGET_SHOWN = 'DYNAMIC_WIDGET_SHOWN',
        DYNAMIC_WIDGET_STARTED = 'DYNAMIC_WIDGET_STARTED',
        STATIC_WIDGET_VOICE_CHAT_BUTTON_PRESSED = 'STATIC_WIDGET_VOICE_CHAT_BUTTON_PRESSED',
        STATIC_WIDGET_TEXT_CHAT_BUTTON_PRESSED = 'STATIC_WIDGET_TEXT_CHAT_BUTTON_PRESSED',
        STATIC_WIDGET_SETTINGS_REQUESTED = 'STATIC_WIDGET_SETTINGS_REQUESTED',
        DYNAMIC_WIDGET_SETTINGS_REQUESTED = 'DYNAMIC_WIDGET_SETTINGS_REQUESTED',
        USER_STAYED_ON_PAGE_WITH_STATIC_WIDGET_FOR_X_SECONDS = 'USER_STAYED_ON_PAGE_WITH_STATIC_WIDGET_FOR_X_SECONDS',
        CLOSED_WIDGET_SHOWN = 'CLOSED_WIDGET_SHOWN',
        DYNAMIC_GREETING_BUTTON_PRESSED = 'DYNAMIC_GREETING_BUTTON_PRESSED',
        DYNAMIC_WIDGET_RECONNECTED = 'DYNAMIC_WIDGET_RECONNECTED',
    }
}

